import { z } from 'zod';
import { createToolSignature } from './tool-signature';
export const searchMyAssignedContactsToolSignature = createToolSignature({
    name: 'searchMyAssignedContacts',
    description:
        'Search for contacts that the user have assigned to any playbook. The query will regex search the name, title and location of their contacts.',
    inputSchema: z.object({
        query: z
            .string()
            .describe(
                "The query to search the user assigned contacts for, will match the contact's name, title, location and the company they work at. (e.g. 'John Doe', 'Software Engineer', 'San Francisco', 'Google')",
            ),
        groupId: z
            .string()
            .describe(
                'The groupId of the playbook to search the contacts in. Pass an empty string to search all playbooks',
            ),
    }),
    outputSchema: z.object({
        count: z.number().describe('The total number of contacts that match the query'),
        contacts: z.array(
            z.object({
                prospectId: z.string().describe('The prospectId of the contact'),
                fullName: z.string().describe('The full name of the contact'),
                occupationTitle: z.string().describe('The work title/role of the contact'),
                location: z.string().describe('The location of the contact'),
                organizationName: z.string().describe('The company the contact works at'),
            }),
        ),
    }),
    toolCallUi: (input) => 'Searching your contacts',
});
